import React from 'react';
import { Controller } from 'react-hook-form';
import { ToggleButton } from 'primereact/togglebutton';

const Toggle = ({ name, control, onLabel, offLabel, tooltip, tooltipOptions, getFormErrorMessage, preValue, onChange, disabled, className}) => (
  <Controller
    name={name}
    control={control}
    render={({ field, fieldState }) => (
      <div className="d-flex flex-column align-items-center w-100">
        <ToggleButton
          id={field.name}
          checked={preValue && field.value === undefined ? preValue : field.value}
          disabled={disabled}
          // onChange={ field.onChange}
          onChange={(e) => {
            field.onChange(e.target.value);
            // Chama a função onChange passada como prop
            onChange && onChange(e.target.value);
          }}
          tooltip={tooltip}
          tooltipOptions={tooltipOptions}
          onLabel={onLabel}
          offLabel={offLabel}
          onIcon="pi pi-check"
          offIcon="pi pi-times"
          className={`w-100 ${className} ${fieldState.error ? "is-invalid" : ""
            }`}
        />
        {getFormErrorMessage(field.name)}
      </div>
    )}
  />
);

export default Toggle;
